import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetOrganizationSettingsQuery } from "../../../graphql/generated";
import { TripEtaStatusDot } from "./TripEtaStatusDot";
import {
  hasLiveEtaDisplay,
  TripLiveEtaDisplayFields,
} from "./tripLiveEtaDisplay";

export const CalendarTripLiveEta = ({
  trip,
}: {
  trip: TripLiveEtaDisplayFields;
}) => {
  const { t } = useTranslation("planning");
  const orgSettingsQuery = useGetOrganizationSettingsQuery();
  const etaEnabled =
    !!orgSettingsQuery.data?.organizationSettings?.dispatching?.enableEta;

  if (!etaEnabled || !hasLiveEtaDisplay(trip)) {
    return null;
  }

  return (
    <Stack data-testid="calendar-trip-live-eta" spacing={0.5} sx={{ mb: 1 }}>
      {trip.nextStopName ? (
        <Typography variant="caption">
          {t("nextStop", "Next Stop")}: {trip.nextStopName}
        </Typography>
      ) : null}
      {trip.etaToNextStopMinutes != null ? (
        <Typography variant="caption">
          {t("etaToNextStop", "ETA To Next Stop")}:{" "}
          {t("etaMinutes", "{{count}} min", {
            count: trip.etaToNextStopMinutes,
          })}
        </Typography>
      ) : null}
      {trip.etaToDeliveryMinutes != null ? (
        <Typography variant="caption">
          {t("etaToDelivery", "ETA To Delivery")}:{" "}
          {t("etaMinutes", "{{count}} min", {
            count: trip.etaToDeliveryMinutes,
          })}
        </Typography>
      ) : null}
      {trip.etaStatus ? (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="caption">
            {t("etaStatus", "ETA Status")}:
          </Typography>
          <TripEtaStatusDot etaStatus={trip.etaStatus} showLabel />
        </Stack>
      ) : null}
    </Stack>
  );
};
